import React, { forwardRef } from 'react';
import { GLOBAL_REVIEWS_ROUTE, MAIN_ROUTE } from "../../../../utils/consts";
import { observer } from "mobx-react-lite";
import {useHistory, useLocation} from "react-router-dom";
import logo from "../../../../Assets/21.png"

import styles from './NavBar.module.css';

import ym from "react-yandex-metrika";
import UserMiniProfile from "../../../profile/UserMiniProfile/UserMiniProfile";

const NavBar = observer(forwardRef((props, ref) => {
    const history = useHistory();
    const location = useLocation();
    const isFavouritesPage = location.pathname === '/favourites';

    return (
        <div
            className={`${styles.navBarWrapper} ${isFavouritesPage ? styles.favouritesPageMod : ''}`}
            ref={ref}
        >
            <div className="container-custom">
                <div className={styles.navBarContent}>
                    <div className={styles.navBarLogo}>
                        <button
                            onClick={() => {
                                history.push(MAIN_ROUTE);
                                ym('reachGoal','history.push(MAIN_ROUTE) LOGO')
                            }}
                            className={styles.logoButton}
                        >
                            <img
                                alt="Логотип"
                                src={logo}
                                className={styles.logoImage}
                            />
                        </button>
                    </div>

                    <div className={styles.userActions}>
                        <button
                            className={styles.reviewButton}
                            onClick={() => {
                                history.push(GLOBAL_REVIEWS_ROUTE);
                                ym('reachGoal','history.push(GLOBAL_REVIEWS_ROUTE)')
                            }}
                        >
                            Отзывы
                        </button>
                        <UserMiniProfile/>
                    </div>
                </div>
            </div>
        </div>
    );
}));

export default NavBar;